import React, { FC } from 'react';

export const InstagramIcon: FC<{ className?: string; href?: string }> = (props) => {
  return (
    <a className={props.className} href={props.href}>
      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.4 4.267a.533.533 0 0 1-.533.533h-2.134a.533.533 0 0 1-.533-.533V2.133c0-.294.238-.533.533-.533h2.134c.295 0 .533.239.533.533v2.134zm0 9.6a.533.533 0 0 1-.533.533H2.133a.533.533 0 0 1-.533-.533V6.933h1.733A4.753 4.753 0 0 0 3.2 8a4.8 4.8 0 1 0 9.6 0c0-.369-.054-.722-.133-1.067H14.4v6.934zm-4.573-8.49l.1.077a3.11 3.11 0 0 1 .598.59l.036.043A3.227 3.227 0 0 1 11.2 8a3.2 3.2 0 1 1-6.4 0 3.218 3.218 0 0 1 .641-1.915l.028-.034a3.14 3.14 0 0 1 .263-.3l.082-.08c.083-.077.17-.15.26-.218.033-.025.065-.051.099-.075a3.174 3.174 0 0 1 3.654 0zM12.8 0H3.2A3.2 3.2 0 0 0 0 3.2v9.6A3.2 3.2 0 0 0 3.2 16h9.6a3.2 3.2 0 0 0 3.2-3.2V3.2A3.2 3.2 0 0 0 12.8 0z"
          fill="#BEBEBE"
          fillRule="evenodd"
        ></path>
      </svg>
    </a>
  );
};
